<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<template>
  <div>
    <h2>Inspección del lienzo de la Virgen de Guadalupe por parte de pintores virreinales. 1751</h2>
    <img @click="imageClicked(0)" src="galerias/guadalupe/g7/G7.jpg" class="mainphoto"/>
    <p class="photo-description">Virgen de Guadalupe con la Santísima Trinidad, San Ignacio de Loyola y San Antonio. Autor Miguel Cabrera. Óleo sobre tela, 1767. Col. Museo de Historia Mexicana</p>
    <p>La Virgen de Guadalupe se popularizó en el siglo XVIII gracias al análisis y calcado de su silueta que realizaron varios pintores como Miguel Cabrera, José de Ibarra, Manuel de Osorio, Juan Patricio Morlete Ruiz, Francisco Antonio Vallejo, José de Alcíbar y José Ventura Arnáez.</p>
    <p>Miguel Cabrera, uno de los mejores pintores virreinales de la Nueva España, publicó en 1756 el texto Maravilla Americana, fruto del estudio de la imagen original de la Virgen de Guadalupe.</p>
    <p>En dicho análisis Miguel Cabrera se maravilla de la conservación de la imagen, la superficie de la misma, la falta de aparejo, la perfecta ejecución, la aparente multiplicidad y complejidad de técnicas... Con todo ello definió una conclusión como especialista, que era “obra milagrosa, y que excede con clarísimas ventajas a cuanto puede llegar la mayor valentía del arte […] es el más auténtico testimonio del milagro”.</p>
    <h5>VER MÁS</h5>
    <p>
      <ul>
        <li><a target="_blank" href="http://cdigital.dgb.uanl.mx/la/1080026900/1080026900.PDF">cdigital.dgb.uanl.mx</a></li>
        <li><a target="_blank" href="https://dhial.org/diccionario/index.php?title=CABRERA,_Miguel">dhial.org</a></li>
      </ul>
    </p>

    <h4>El s.XVII y s.XVIII como generador de grandes obras pictóricas guadalupanas</h4>
    <img @click="imageClicked(1)" class="mainphoto" src="galerias/guadalupe/g7/G7_A.jpg"/>
    <p>Durante los siglos XVII y XVIII se dio un auge de las representaciones guadalupanas por parte de importantes artistas virreinales y fueron muy difundidas en la Nueva España  y otros territorios dentro y fuera de la monarquía hispánica.</p>
    <p>Imagen del “Retablo de la Virgen de Guadalupe, Fray Juan de Zumárraga y Juan Diego” de Miguel Cabrera (CA.1695 – 1768, Museo Nacional de Arte INBA, Acervo Constitutivo, 1982).</p>
    <p>Si deseas conocer más:
      <ul>
        <li><a target="_blank" href="http://munal.emuseum.com/objects/2103/retablo-de-la-virgen-de-guadalupe-fray-juan-de-zumarraga-y">munal.emuseum.com</a></li>
        <li>
          <a target="_blank" href="https://www.mexicana.cultura.gob.mx/es/repositorio/detalle?id=_suri:MUNAL:TransObject:5bce8cb27a8a02074f835dd2&word=Fray%20Juan%20de%20San%20Miguel,&r=1&t=523696">
            www.mexicana.cultura.gob.mx
          </a>
        </li>
      </ul>
    </p>
    
    <h4>La epidemia del Matlazáhuatl: se publica El Escudo de Armas de la Ciudad de México (1746)</h4>
    <img @click="imageClicked(2)" class="mainphoto" src="galerias/guadalupe/g7/G7_B.jpg"/>
    <p class="photo-description">Frontispicio del libro Escudo de Armas de la Ciudad de México.  José de Ibarra y Baltasar Troncoso, impresión litografica, 1746. Col. Biblioteca  John Carter, Universidad de Brown.</p>
    <p>La Virgen de Guadalupe siempre ha sido referente de la devoción popular ante las enfermedades, sequías, inundaciones e incluso terremotos, entre otras acciones.</p>
    <p>En 1737 una nueva epidemia, esta vez de matlazáhuatl, asoló la Ciudad de México. La petición de protección y fuerzas se vio significativamente representada por la vinculación de la Virgen de Guadalupe al Escudo de Armas de la Ciudad de México en 1746.</p>
    <p>Si deseas conocer más:
      <ul>
        <li><a target="_blank" href="http://www.adabi.org.mx/vufind/Record/195903">www.adabi.org.mx</a></li>
      </ul>
    </p>
  </div>
</template>

<script>
export default {
  name: "Sala2m6",
  data() {
    return {};
  },
  methods: {
    imageClicked(idx) {
      this.$emit("onImageClicked", idx);
    }
  },
  components: {},
  props: {},
  mounted() {},
};
</script>
